import React, { useEffect } from "react"
import { Container, Col } from "react-bootstrap"
import { useSelector, useDispatch, shallowEqual, batch } from "react-redux"
import PolicyInformation from "./policyInformation"
import RequiredDocuments from "./requiredDocuments"
import LossDamageDetails from "./lossDamageDetails"
import ReviewClaim from "./reviewClaim"
import SubmittedClaim from "./submittedClaim"

import * as API from "../../services/httpService"
import {
  updateValidFormData,
  updateUiData,
  saveDataFromAPI,
  controlLoading,
} from "../../redux/actions"
import * as Constants from "../../common/constants"
import { navigate } from "gatsby"

const BaseForm = () => {
  const uiData = useSelector(state => state.uiData)
  const { maxPageNumber } = uiData
  const claimData = useSelector(state => state.claimData, shallowEqual)

  // useEffect(() => {}, shallowEqual)
  const dispatch = useDispatch()

  useEffect(() => {
    const GetDataPromise = API.apiPostRequest("/Claim/GetData", null, null)

    const OccupationPromise = API.apiPostRequest(
      "/Claim/Occupation",
      null,
      null
    )

    const BankPromise = API.apiPostRequest("/Claim/BankList", null, null)

    Promise.all([GetDataPromise, OccupationPromise, BankPromise])
      .then(values => {
        batch(() => {
          if (values[0].data) {
            dispatch(updateValidFormData("claimFireDetail", values[0].data))
          }
          if (values[1].data) {
            let occupationList = [...values[1].data]
            let otherIndex = occupationList
              .map(function(e) {
                return e.Occupation
              })
              .indexOf("Others")

            //Move "Others" to last place
            occupationList.push(occupationList.splice(otherIndex, 1)[0])

            dispatch(saveDataFromAPI("occupationList", occupationList))
          }
          if (values[2].data) {
            // const emptyBank = [
            //   {
            //     Bank_Id: 0,
            //     Bank_Name: "",
            //     BIC: "",
            //     IsValid: true,
            //     RegexValidation: "",
            //     RegexValidationJs: "",
            //     ErrorMessage: "",
            //   },
            // ]
            // const banklistResult = [emptyBank].concat(values[2].data)
            // dispatch(saveDataFromAPI("bankList", banklistResult))
            dispatch(saveDataFromAPI("bankList", values[2].data))
          }

          if (values[0].data.hideHeaderFooter?.toLowerCase() == "true") {
            dispatch(updateUiData("hideHeaderFooter", true))
          }

          dispatch(controlLoading())
        })
      })
      .catch(error => {
        navigate("ErrorOccurred")
      })
  }, [dispatch])

  return (
    <>
      <Container className="body-content mt-md-4">
        {/* Pages
          1. Policy Information + The Insured
          2. Upload Required Documents
          3. The Loss or Damage
          6. Claims Payout Instruction
          7. Summary
          8. Submitted Result
        */}

        <Col xs={12}>
          {/* 1. Policy Information + The Insured */}
          {maxPageNumber >= Constants.policyInfoPageNumber && (
            <PolicyInformation claimData={claimData} uiData={uiData} />
          )}

          {/* 2. Upload Required Documents */}
          {maxPageNumber >= Constants.requiredDocumentPageNumber && (
            <RequiredDocuments claimData={claimData} uiData={uiData} />
          )}

          {/* 7. Summary */}
          {/* TemporaryHide */}
          {/* {maxPageNumber >= Constants.reviewPageNumber && (
            <ReviewClaim claimData={claimData} uiData={uiData} />
          )} */}

          {/* 3. The Loss or Damage */}
          {maxPageNumber >= Constants.lossDamageDetailsPageNumber && (
            <LossDamageDetails claimData={claimData} uiData={uiData} />
          )}

          {/* 8. Submitted Result */}
          {maxPageNumber === Constants.submittedClaimPageNumber && (
            <SubmittedClaim uiData={uiData}></SubmittedClaim>
          )}
        </Col>
      </Container>
    </>
  )
}

export default BaseForm
